<script lang="ts" setup>
import LaptopSidebar from '~/components/navigation/laptop/sidebar/LaptopSidebar.vue'
import { useFeatureIndicator } from '~/composables/useFeatureIndicator'
import { menuList } from '~/constants/menu.const'
import { IFeaturedMenuKey, IFeaturedType } from '~/types/featured.type'
import type { MenuType } from '~/types/menu.type'

// TODO: 사이드바 리스트 통합 필요
const route = useRoute()
const { partFeaturedMap } = useFeatureIndicator(IFeaturedMenuKey.SIDEBAR)

const getFeatured = (menuItem: MenuType) => {
  const featuredSet = new Set<IFeaturedType>()
  // 원본 featured 보존
  if (menuItem.featured) {
    menuItem.featured.forEach(featuredType => {
      featuredSet.add(featuredType)
    })
  }
  // 자식 아이템의 featured 집계 (부모 메뉴용)
  if (menuItem.underItems) {
    menuItem.underItems.forEach(underItem => {
      if (underItem.featured) {
        underItem.featured.forEach(featuredType => {
          featuredSet.add(featuredType)
        })
      }
    })
  }
  // API에서 가져온 동적 featured 추가
  const featuredType = partFeaturedMap.value?.get(menuItem.key)
  if (featuredType) {
    featuredSet.add(featuredType)
  }
  return Array.from(featuredSet)
}

const sidebarList = computed<MenuType[]>(() => {
  return menuList.map((item) => {
    const parsedItem = {
      ...item,
      isActive: isActive(item),
      featured: getFeatured(item)
    }
    if (item.underItems) {
      // 원본 menuList를 수정하지 않고 새 객체에 underItems 할당
      parsedItem.underItems = item.underItems.map((underItem: MenuType) => {
        return {
          ...underItem,
          featured: getFeatured(underItem)
        }
      })
    }
    return parsedItem
  })
})

const isActive = (item: MenuType) => {
  const path = route.path
  if (!item.to) {
    return item.activeRegex?.test(path) || item.underItems?.some(underItem => underItem.isActive) || false
  }
  if (item.external) return false
  return item.activeRegex?.test(path) || item.to.split('/')[1] === path.split('/')[1]
}
</script>

<template>
  <LaptopSidebar :list="sidebarList" />
</template>

<style scoped>
</style>